// extracted by mini-css-extract-plugin
module.exports = {"root":"DefinitionList_root__EV70S","type":"DefinitionList_type__3ajEo","description":"DefinitionList_description__1ksgZ"};